module.exports = __webpack_public_path__ + "img/follow.2b1bb2f1.jpg";